import getters from "./VotreProjectGetters";
import actions from "./VotreProjectActions";
import mutations from "./VotreProjectMutations";

const state = {
    entreprise: {},
    project: {},
    offers: [],
    clients: []
};

export default {
    state,
    getters,
    actions,
    mutations
};
